<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item :to="'/teacher/class'">Classes</b-breadcrumb-item>
      <b-breadcrumb-item active>
        {{ $t("class-student.sub-titulo-tab-report") }}s:
        <template>
          {{
            pIsGroup
              ? "Group " + pCodeGroup
              : pStudent != null
              ? pStudent[0].name
              : "-"
          }}
        </template>
      </b-breadcrumb-item>
    </b-breadcrumb>
    <div class="card card-next-class-2" v-if="classStudent != null">
      <div class="left">
        <img src="@/assets/img/girdRequest-2.png" />
        <h6 class="sub-title">
          <span>{{ $t("horario.next-class.nextClass") }}</span>
        </h6>
      </div>
      <div>
        <div class="right">
          <span><icon name="calendar" />{{ classStudent.strStartDate }}</span>
          <span><icon name="time" />{{ classStudent.strStartEndDate }}</span>
          <span style="white-space: normal">
            <icon
              v-if="classStudent.flagGroup"
              name="group"
              style="width: 17px"
            />
            <icon v-else name="user-2" style="width: 17px" />
            {{ classStudent.className }}
          </span>
        </div>
      </div>
      <button
        type="button"
        @click="
          openLinkClassLocal(
            classStudent.linkClass,
            $moment,
            classStudent.startDateValidate,
            classStudent.endDateValidate
          )
        "
        class="btn btn-primary"
        :class="
          classStudent && classStudent.linkClass != null ? '' : 'disabled'
        "
      >
        <icon name="video" />
        {{ $t("horario.next-class.join") }}
      </button>
      <!-- <b-button variant="primary"><b-icon icon="camera-video" aria-hidden="true"></b-icon>{{$t('horario.next-class.button-pass')}}</b-button> -->
    </div>
    <div class="card px-5 py-4">
      <div class="back-step mt-0" @click="$router.go(-1)">
        <img class="svg" src="@/assets/icons/icon-arrow-left.svg" />Return
      </div>
      <div class="d-flex justify-content-center align-items-center mb-4">
        <h6 class="sub-title mb-0">
          <span class="d-flex justify-content-center align-items-center">
            {{
              pIsGroup
                ? "Group " + pCodeGroup
                : pStudent != null
                ? pStudent[0].name
                : "-"
            }}
            <icon
              v-if="pIsGroup == true"
              name="alert"
              class="ml-2"
              id="btnTooltipStudentGroup"
              style="cursor: pointer"
            ></icon
          ></span>
        </h6>
        <svg
          v-if="vpTotalHoursSchedule >= 0 && pDuration > 0 && flagHoursSchedule"
          class="circle-chart ml-5"
          viewBox="0 0 36.83098862 36.83098862"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            class="circle-chart__background"
            cx="17.9"
            cy="18.9"
            r="15.9"
          ></circle>
          <circle
            v-if="vpTotalHoursSchedule > 0"
            class="circle-chart__circle warning-stroke"
            :stroke-dasharray="vpPercentageCompleted + ',100'"
            cx="17.9"
            cy="17.9"
            r="15.9"
          ></circle>
          <g class="circle-chart__info">
            <text class="circle-chart__text" x="18" y="15.5">
              {{ vpTotalHoursSchedule + "/" + pDuration }}
            </text>
            <text class="circle-chart__text" x="18" y="22">hours</text>
          </g>
        </svg>
      </div>
      <b-tooltip
        v-if="pIsGroup == true"
        target="btnTooltipStudentGroup"
        id="tooltipStudentGroup"
        placement="right"
      >
        <ul>
          <li v-for="(row, i) of pStudent" :key="i">{{ row.name }}</li>
        </ul>
      </b-tooltip>
      <b-form inline class="align-items-end mb-4">
        <b-form-group
          class="mr-4"
          :label="this.$t('table-class-header.date')"
          style="max-width: 235px"
        >
          <date-range-picker
            ref="picker"
            opens="right"
            :locale-data="{ firstDay: 1, format: 'mm-dd-yyyy' }"
            v-model="dateRange"
            @update="getListSelect"
          >
          </date-range-picker>
        </b-form-group>
        <!--      <b-form-group
          class="mr-2"
          label="Class Status"
          style="max-width: 200px"
        >
          <CustomSelect
            @input="idValueSelectselectedStatus"
            :options="optionsStatus"
            value="valor"
            label="descripcion"
            :default="$t('filter.text')"
            @change="getListSelect()"
          />
        </b-form-group> -->
        <b-form-group
          label="Class Report"
          class="mr-2"
          style="max-width: 200px"
        >
          <CustomSelect
            @input="idValueSelectselectedReport"
            :options="optionsReport"
            value="id"
            label="descripcion"
            :default="$t('filter.text')"
            @change="getListSelect()"
          />
        </b-form-group>
        <b-form-group class="ml-auto" style="flex: none">
          <button
            :disabled="isPlanActive"
            type="button"
            class="btn btn-outline-primary"
            @click="validatePlanActive()"
          >
            <icon name="table-create" /> Create class report
          </button>
        </b-form-group>
        <!-- <b-form-group class="mr-2" :label="$t('class-teacher.student')">
                    <v-autocomplete :placeholder="$t('reusables.searchName')" :items="items" v-model="item" :min-len="0" :get-label="getLabel" :component-item='template' @update-items="updateItems" :auto-select-one-item="false">
                    </v-autocomplete>
                  </b-form-group>
           -->
      </b-form>
      <b-table-simple
        responsive
        hover
        :aria-busy="isBusy"
        id="table-request-class"
        style="white-space: pre-line; display: block !important"
      >
        <b-thead>
          <b-th class="text-center" style="width: 15%">Class Status</b-th>
          <b-th style="width: 8%">Date</b-th>
          <b-th style="width: 20%">Time</b-th>
          <b-th style="width: 9%">Duration</b-th>
          <b-th style="width: 8%">Hours Used</b-th>
          <b-th class="text-center">Teacher</b-th>
          <b-th class="text-center">Total</b-th>
          <b-th class="text-center" style="width: 4%">Paid</b-th>
          <b-th class="text-center" style="width: 9%">Class Report</b-th>
        </b-thead>
        <b-tr v-if="isBusy" class="b-table-busy-slot">
          <b-td colspan="10">
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong> {{ $t("ClassRequest.Loading") }}...</strong>
            </div>
          </b-td>
        </b-tr>
        <b-tr v-else>
          <b-td colspan="10" v-if="itemsTable.length == 0">{{
            $t("reusables.empty-text")
          }}</b-td>
        </b-tr>
        <b-tbody>
          <b-tr v-for="(row, i) of itemsTable" :key="i">
            <template v-if="row.isTotal == true">
              <b-td colspan="10" class="data-package">
                <span class="d-flex align-items-center justify-content-center">
                  Package:
                  {{
                    row.groupPlan.flagPlanTest
                      ? $t("reusables.test-class")
                      : ("" + row.groupPlan.duration).concat(" hours")
                  }}
                </span>
              </b-td>
            </template>

            <template v-else>
              <b-td>
                <label :style="{ color: row.statusColor }">{{
                  row.status
                }}</label></b-td
              >
              <b-td>
                <label>{{ row.date }}</label>
              </b-td>
              <b-td>
                <label>{{ row.hours }}</label></b-td
              >
              <b-td>
                <label>{{ row.strClassDuration }}</label></b-td
              >
              <b-td v-if="row.hoursUse > 0 && row.duration > 0">{{
                row.hoursUse + "/" + row.duration
              }}</b-td>
              <b-td v-else>-</b-td>
              <b-td v-if="row.personsTeachersPendingPaymentClassId > 0">{{
                row.personsTeacher.strFullName
              }}</b-td>
              <b-td v-else>-</b-td>
              <b-td v-if="row.personsTeachersPendingPaymentClassId > 0">{{
                row.amount
              }}</b-td>
              <b-td v-else>-</b-td>
              <!-- getIconReport(row.statusValue, row.groupPlanClassId) -->
              <b-td
                v-if="
                  row.personsTeachersPendingPaymentClassId > 0 && row.flagPaid
                "
                class="text-center"
              >
                <icon name="check" style="fill: #00b050; width: 21px" />
              </b-td>
              <b-td v-else>-</b-td>
              <b-td
                ><div
                  v-if="getShowReport(row.statusValue)"
                  class="d-flex justify-content-center"
                >
                  <a
                    @click="redirectToClassReport(row)"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                    class="bold"
                  >
                    {{ row.report }}
                  </a>

                </div>
                <div v-else>
                  <span>
                    {{ row.report }}
                  </span>
                </div></b-td
              >
            </template>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <div class="overflow-auto content-pagination" style="display: flex">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="pageSize"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
        {{ (currentPage - 1) * pageSize + 1 }} -
        {{
          pageSize > totalRows
            ? totalRows
            : pageSize * currentPage > totalRows
            ? totalRows
            : pageSize * currentPage
        }}
        /{{ totalRows }} items
      </div>
    </div>
    <b-modal id="modal-next-linkClass" :centered="true">
      <template #modal-header="{ close }">
        <img class="close" src="@/assets/img/close_red.png" @click="close()" />
      </template>
      <p class="text-center mb-0">{{ messageLinkClassResult }}</p>
      <template #modal-footer>
        <b-button
          @click="$bvModal.hide('modal-next-linkClass')"
          variant="primary"
          >Aceptar</b-button
        >
      </template>
    </b-modal>
    <b-modal id="modal-plan-active" :centered="true">
      <template #modal-header="{ close }">
        <img class="close" src="@/assets/img/close_red.png" @click="close()" />
      </template>
      <p class="text-center mb-0">{{ message }}</p>
      <template #modal-footer>
        <b-button @click="$bvModal.hide('modal-plan-active')" variant="primary"
          >Aceptar</b-button
        >
      </template>
    </b-modal>
  </div>
</template>
<script>
import CustomSelect from "@/components/form/select";
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import * as Constants from "@/assets/js/appConstants";
import {
  horarioObtenerColorClaseConsolidado,
  horarioObtenerNameClaseENConsolidado,
  openLinkClass,
  getNextClassDate,
  getNextClassTime,
  convertTimeToUserTimeFormat,
} from "@/assets/js/util.js";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import ItemTemplate from "@/views/teacher/class/ItemTemplate ";
export default {
  components: {
    DateRangePicker,
    CustomSelect,
  },
  data() {
    return {
      flagHoursSchedule: false,
      vpPercentageCompleted: 0,
      vpTotalHoursSchedule: 0,
      lang: localStorage.getItem("lang"),
      messageLinkClassResult: null,
      classStudent: null,
      filterStudent: "",
      currentPage: 1,
      pageSize: 50,
      totalRows: 0,
      transProps: {
        // Transition name
        name: "flip-list",
      },
      isBusy: false,
      optionsReport: [],
      optionsStatus: [],
      selectedStatus: null,
      selectedReport: null,
      itemsTable: [],
      dateRange: { startDate: null, endDate: null },
      /*value: '',
          suggestionAttribute: 'descripcion',
          suggestions: [],
          selectedEvent: "",*/
      item: null,
      items: [],
      template: ItemTemplate,
      pGroupPlan: null,
      isPlanActive: false,
      message: "",
    };
  },
  props: {
    filterGroupId: Number,
    filterNameStudent: String,
    pIsGroup: Boolean,
    pStudent: Array,
    pCodeGroup: String,
    pTotalHoursSchedule: Number,
    pDuration: Number,
    pPercentageCompleted: Number,
  },
  computed: {
    groupId: {
      get() {
        return this.$store.state.group_id;
      },
      set(value) {
        this.$store.commit("mutateGroupId", value);
      },
    },
    User: {
      get() {
        return this.$store.state.user;
      },
    },
  },
  watch: {
    currentPage() {
      this.isBusy = true;
      this.getListClassTeacher();
    },
  },
  created() {
    this.vpPercentageCompleted = this.pPercentageCompleted;
    this.vpTotalHoursSchedule = this.pTotalHoursSchedule;
    if (this.filterGroupId) {
      this.item = {
        id: this.filterGroupId,
        name: this.filterNameStudent,
      };
    } else {
      this.$router
        .push({
          name: "teacher-class",
        })
        .catch((err) => {});
    }
    let startDate = this.$moment().toDate();
    let endDate = this.$moment().subtract(1, "months").toDate();
    this.dateRange = {
      startDate: endDate,
      endDate: startDate,
    };
    this.isBusy = true;
    this.getListCombo();
    this.getListClassTeacher();
  },
  mounted() {},
  methods: {
    redirectToClassReport(row) {
      var strPagePrev = {
        filterGroupId: this.filterGroupId,
        filterNameStudent: this.filterNameStudent,
        pIsGroup: this.pIsGroup,
        pStudent: this.pStudent,
        pCodeGroup: this.pCodeGroup,
        pTotalHoursSchedule: this.pTotalHoursSchedule,
        pDuration: this.pDuration,
        pPercentageCompleted: this.pPercentageCompleted,
      };
      var _param = btoa(JSON.stringify(strPagePrev));
      this.$router.push({
        name: "teacher-class-report",
        params: {
          id: row.id,
          classId: row.groupPlanClassId,
          flagReport: false,
          flagTeacherReport: true,
          flagNoSchedule: row.noSchedule,
          pGroupPlanId: row.groupPlanId,
          flagPaid: row.flagPaid,
          pagePrevId: _param,
        },
      });
    },
    validatePlanActive() {
      this.isPlanActive = true;
      let params = {
        GroupId: this.filterGroupId,
        TeacherId: this.User.personTeacherId,
      };

      baseInstanceAxios
        .get(`${this.apiURL}/resources/PersonsTeachers/ValidatePlanActive`, {
          params,
        })
        .then((response) => {
          this.pGroupPlan = response.data.entity;
          if (
            this.pGroupPlan != null &&
            this.pGroupPlan.flagPlanTest == false
          ) {
            var strPagePrev = {
              filterGroupId: this.filterGroupId,
              filterNameStudent: this.filterNameStudent,
              pIsGroup: this.pIsGroup,
              pStudent: this.pStudent,
              pCodeGroup: this.pCodeGroup,
              pTotalHoursSchedule: this.pTotalHoursSchedule,
              pDuration: this.pDuration,
              pPercentageCompleted: this.pPercentageCompleted,
            };
            var _param = btoa(JSON.stringify(strPagePrev));
            this.$router.push({
              name: "teacher-class-report",
              params: {
                id: 0,
                classId: 0,
                flagReport: false,
                flagTeacherReport: true,
                flagNoSchedule: true,
                pGroupPlanId: this.pGroupPlan.id,
                flagPaid: false,
                pagePrevId: _param,
              },
            });
          } else {
            this.message = this.$t("report-class.modal.title-planActive");
            this.$bvModal.show("modal-plan-active");
          }
          this.isPlanActive = false;
        })
        .catch(() => {
          this.isPlanActive = false;
        });
    },
    getLabel(item) {
      this.item = item;
      this.getListClassTeacher();
      return item?.name;
    },
    updateItems(text) {
      let params = {
        Id: this.User.personTeacherId,
        Filter: text,
      };

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/PersonsTeachers/ComboStudentByAutocomplete`,
          { params }
        )
        .then((response) => {
          if (response.data && response.data.list) {
            this.items = response.data.list.map((x) => ({
              id: x.id,
              name: x.descripcion,
            }));
          }
        });
    },
    getListCombo() {
      let data = {
        PersonTeacherId: this.User.personTeacherId,
        isNextClass: false,
        groupId: this.filterGroupId,
      };
      let format_time_validate = "YYYY-MM-DDTHH:mm:ss";
      let format_day = "MM/DD/YYYY";
      let format_time = "h:mm a";
      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/PersonsTeachers/GetComboScheduleTeacherDetailClass`,
          { params: data }
        )
        .then((response) => {
          if (
            this.$route.params.pFlagRegistroClass != undefined &&
            this.$route.params.pFlagRegistroClass &&
            response.data.valueData > 0
          ) {
            this.vpTotalHoursSchedule = response.data.valueData;
            var totalHoras = (this.vpTotalHoursSchedule / this.pDuration) * 100;
            this.vpPercentageCompleted = totalHoras;
          }

          if (response.data.entity.teacherScheduleClass != null) {
            this.classStudent = {
              className: response.data.entity.teacherScheduleClass.className,
              classPhoto: response.data.entity.teacherScheduleClass.classPhoto,
              flagGroup: response.data.entity.teacherScheduleClass.flagGroup,

              strStartDate: getNextClassDate(
                response.data.entity.teacherScheduleClass.startDate,
                this.$store.state.user.timeZoneName,
                this.$moment,
                format_day
              ),
              strStartEndDate: getNextClassTime(
                response.data.entity.teacherScheduleClass.startDate,
                response.data.entity.teacherScheduleClass.endDate,
                this.$store.state.user.timeZoneName,
                this.$moment,
                format_time
              ),
              linkClass: response.data.entity.teacherScheduleClass.linkClass,

              startDateValidate: convertTimeToUserTimeFormat(
                response.data.entity.teacherScheduleClass.startDate,
                this.$store.state.user.timeZoneName,
                this.$moment,
                format_time_validate
              ),
              endDateValidate: convertTimeToUserTimeFormat(
                response.data.entity.teacherScheduleClass.endDate,
                this.$store.state.user.timeZoneName,
                this.$moment,
                format_time_validate
              ),
            };
          }
          response.data.entity.listStatusClass.forEach((element) => {
            element.descripcion = horarioObtenerNameClaseENConsolidado(
              element.valor
            );
          });
          response.data.entity.listEstadoReporteEnum.forEach((element) => {
            if (element.id == Constants.STATUS_REPORT_ENUM.REPORT.ID) {
              element.descripcion =
                this.lang == "en"
                  ? Constants.STATUS_REPORT_ENUM.REPORT.NAME_EN
                  : element.descripcion;
            }
            if (element.id == Constants.STATUS_REPORT_ENUM.PENDING.ID) {
              element.descripcion =
                this.lang == "en"
                  ? Constants.STATUS_REPORT_ENUM.PENDING.NAME_EN
                  : element.descripcion;
            }
          });
          //this.optionsStatus = response.data.entity.listStatusClass; //.map(x => ({ id: x.id, descripcion: x.descripcion }));
          this.optionsReport = response.data.entity.listEstadoReporteEnum; //.map(x => ({ id: x.id, descripcion: x.name }));
          this.flagHoursSchedule = true;
        });
    },
    getListSelect() {
      this.isBusy = true;
      this.itemsTable = [];
      this.currentPage = 1;
      this.getListClassTeacher();
    },
    idValueSelectselectedStatus(event) {
      this.selectedStatus = event;
    },
    idValueSelectselectedReport(event) {
      this.selectedReport = event;
    },
    getListClassTeacher() {
      let data = {
        Page: this.currentPage,
        Size: this.pageSize,
        PersonTeacherId: this.User.personTeacherId,
        StateClassId: this.selectedStatus,
        FechaIni: this.$moment(this.dateRange.startDate).format(
          "YYYY-MM-DDT00:00:00"
        ),
        FechaFin: this.$moment(this.dateRange.endDate).format(
          "YYYY-MM-DDT23:59:59"
        ),
        EstadoReporte: this.selectedReport,
        GroupId: this.item ? this.item.id : null,
      };
      let format_day = "MM/DD/YYYY";
      let format_time = "h:mm a";
      this.itemsTable = [];
      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/PersonsTeachers/GetListScheduleTeacherDetailClass`,
          { params: data }
        )
        .then((response) => {
          this.totalRows = response.data.rows;

          if (response.data.entity.scheduleDetail != null) {
            let data = [];
            if (this.currentPage != 1)
              data[(this.currentPage - 1) * this.pageSize - 1] = {};

            let dataResponse = response.data.entity.scheduleDetail.map((x) => {
              if (x.isTotal) {
                return {
                  id: x.id,
                  isTotal: x.isTotal,
                  groupPlan: x.groupPlan,
                  groupPlanClassId: x.groupPlanClassId,
                };
              } else {
                return {
                  id: x.id,
                  isTotal: x.isTotal,
                  noSchedule: x.noSchedule,
                  groupPlanId: x.groupPlanId,
                  status: horarioObtenerNameClaseENConsolidado(
                    x.stateClass.strValue
                  ), //x.stateClass.name,
                  statusValue: x.stateClass.value,
                  statusColor: horarioObtenerColorClaseConsolidado(
                    x.stateClass.strValue
                  ),

                  date: getNextClassDate(
                    x.startDate,
                    this.$store.state.user.timeZoneName,
                    this.$moment,
                    format_day
                  ),
                  hours: getNextClassTime(
                    x.startDate,
                    x.endDate,
                    this.$store.state.user.timeZoneName,
                    this.$moment,
                    format_time
                  ),
                  subjects: x.subjectsName.replaceAll("|", "\n"),
                  subjects_EN: x.subjectsName_EN.replaceAll("|", "\n"),
                  groupPlanClassId: x.groupPlanClassId,
                  paid: this.getValidationColumnReport(
                    x.stateClass.value,
                    x.groupPlanClassId
                  ),
                  report: this.getValidationColumnReport(
                    x.stateClass.value,
                    x.groupPlanClassId
                  ),
                  startDate: x.startDate,
                  endDate: x.endDate,
                  totalHoursSchedule: x.totalHoursSchedule,
                  percentageCompleted: `${x.percentHoursCompleted}, 100`,
                  hoursUse: x.hoursUse,
                  duration: x.duration,
                  strClassDuration: x.strClassDuration,
                  personsTeachersPendingPaymentClassId:
                    x.personsTeachersPendingPaymentClassId,
                  flagPaid: x.flagPaid,
                  amount: x.amount,
                  personsTeacher: x.personsTeacher.person,
                };
              }
            });

            // Deduplicate rows with same startDate+endDate (duplicate reports for the same slot),
            // keeping the most complete record: paid > has payment entry > has report > first seen
            const bestBySlot = {};
            dataResponse.forEach(row => {
              if (!row || row.isTotal) return;
              const key = `${row.startDate}_${row.endDate}`;
              const score = (row.hoursUse > 0 ? 8 : 0) + (row.flagPaid ? 4 : 0) + (row.personsTeachersPendingPaymentClassId > 0 ? 2 : 0) + (row.groupPlanClassId > 0 ? 1 : 0);
              if (!bestBySlot[key] || score > bestBySlot[key].score) {
                bestBySlot[key] = { row, score };
              }
            });
            const dedupedResponse = dataResponse.filter(row => {
              if (!row || row.isTotal) return true;
              const key = `${row.startDate}_${row.endDate}`;
              return bestBySlot[key].row === row;
            });

            this.itemsTable = dedupedResponse;
            const firstNonTotal = dedupedResponse.find(x => x && !x.isTotal);
            if (firstNonTotal && firstNonTotal.totalHoursSchedule !== undefined) {
              this.vpTotalHoursSchedule = firstNonTotal.totalHoursSchedule;
              if (this.pDuration > 0) {
                this.vpPercentageCompleted =
                  (this.vpTotalHoursSchedule / this.pDuration) * 100;
              }
            }
          }
          this.isBusy = false;
        });
    },
    formatClassDuration(item) {
      var duration = "";

      var milliseconds = this.$moment
        .duration(this.$moment(item.endDate).diff(this.$moment(item.startDate)))
        .asMilliseconds();
      var hours = Math.trunc(this.$moment.duration(milliseconds).asHours());
      var minutes = this.$moment.duration(milliseconds).minutes();

      if (hours < 1) {
        duration = this.$moment.utc(milliseconds).format("mm [min.]");
      } else if (hours == 1 && minutes == 0) {
        duration = this.$moment.utc(milliseconds).format("H [hr.]");
      } else if (hours == 1 && minutes > 0) {
        duration = this.$moment.utc(milliseconds).format("H [hr.] mm [min.]");
      } else if (hours > 0 && minutes == 0) {
        duration = this.$moment.utc(milliseconds).format("H [hrs.]");
      } else {
        duration = this.$moment.utc(milliseconds).format("H [hrs.] mm [min.]");
      }

      return duration;
    },
    getIconReport(state, groupPlanClassId) {
      let states = [
        Constants.CALENDAR_STATUS.COMPLETED.VALUE,
        Constants.CALENDAR_STATUS.UNATTENDANCE_TEACHER.VALUE,
        Constants.CALENDAR_STATUS.UNATTENDANCE_STUDENT.VALUE,
      ];

      return states.includes(state) && groupPlanClassId;
    },
    getShowReport(state) {
      let states = [
        Constants.CALENDAR_STATUS.COMPLETED.VALUE,
        Constants.CALENDAR_STATUS.PENDING_REPORT.VALUE,
        Constants.CALENDAR_STATUS.UNATTENDANCE_TEACHER.VALUE,
        Constants.CALENDAR_STATUS.UNATTENDANCE_STUDENT.VALUE,
        Constants.CALENDAR_STATUS.CANCELED_STUDENT.VALUE,
        Constants.CALENDAR_STATUS.CANCELED_TEACHER.VALUE,
      ];

      return states.includes(state);
    },
    getValidationColumnReport(state, groupPlanClassId) {
      let textReturn = "";

      switch (state) {
        case Constants.CALENDAR_STATUS.PENDIENT.VALUE:
        case Constants.CALENDAR_STATUS.CONFIRM.VALUE:
        case Constants.CALENDAR_STATUS.UNAVAILABLE.VALUE:
          textReturn = "";
          break;
        case Constants.CALENDAR_STATUS.CANCELED_TEACHER.VALUE:
        case Constants.CALENDAR_STATUS.CANCELED_STUDENT.VALUE:
          textReturn = groupPlanClassId ? "See" : "Enter";
          break;
        case Constants.CALENDAR_STATUS.UNATTENDANCE_TEACHER.VALUE:
        case Constants.CALENDAR_STATUS.UNATTENDANCE_STUDENT.VALUE:
          textReturn = groupPlanClassId ? "See" : "Enter";
          break;
        case Constants.CALENDAR_STATUS.PENDING_REPORT.VALUE:
          textReturn = "Enter";
          break;
        case Constants.CALENDAR_STATUS.COMPLETED.VALUE:
          textReturn = "See";
          break;
      }

      return textReturn;
    },
    openLinkClassLocal(linkClass, moment, startDate, endDate) {
      this.messageLinkClassResult = null;
      let result = openLinkClass(
        linkClass,
        moment,
        startDate,
        endDate,
        this.$store.state.user.timeZoneName
      );
      if (result != "") {
        this.messageLinkClassResult = result;
        this.$bvModal.show("modal-next-linkClass");
      }
    },
  },
};
</script>
<style>
#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  font-family: monospace;
  font-size: 20px;
  border: 1px solid #616161;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  overflow: scroll;
  max-height: 200px;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results_item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results_title {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results_item:active,
.autosuggest__results .autosuggest__results_item:hover,
.autosuggest__results .autosuggest__results_item:focus,
.autosuggest__results
  .autosuggest__results_item.autosuggest__results_item-highlighted {
  background-color: #ddd;
}
</style>
